import { Logger } from "@feature-hub/core";
import { createFetchJson } from "@volkswagen-onehub/fetch-json";
import { CommonFeatureAppConfig } from "./types/common-feature-app-config";
import { MinimalResponse } from "@volkswagen-onehub/fetch-json/lib/create-fetch-json";

/**
 * initialize the fetch json once per application or node invocation
 * @param applicationName name of the application
 * @param logger to log fetch calls
 * @param config the mock ids and mock server configuration
 */
export function initializeFetchJson(
  applicationName: string,
  logger: Logger,
  config: CommonFeatureAppConfig | undefined,
  customFetch?: (
    input: string,
    init?: {
      headers?: Record<string, string>;
      method?: "GET" | "POST";
      body?: string;
    }
  ) => Promise<MinimalResponse>
) {
  const fetchJson = createFetchJson({
    applicationName,
    logger,
    fetch: customFetch || fetch,
  });
  const { mockIds, mocksServerConfig } = config || {};

  if (mockIds) {
    fetchJson.initialize({
      mockIds: mockIds.split("-"),
      mocksServerConfig,
    });
  }
}
